<template>
    <RedesignInputNumber
        v-model="model"
        :min-value="minValue"
        :max-value="maxValue"
        :step="1"
    />
</template>

<script setup lang="ts">
import RedesignInputNumber from '@/components/RedesignBaseComponents/Inputs/RedesignInputNumber.vue'
import { computed } from 'vue'

const props = defineProps<{
    value?: number | string
    minValue?: number
    maxValue?: number
}>()

const emit = defineEmits([ 'update:value', 'input' ])

const model = computed({
    get: () => props.value !== undefined ? +props.value : props.value,
    set: (value) => {
        emit('update:value', value)
        emit('input', value)
    }
})

</script>

